import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import { Size } from '../../constants.js';
import './Button.scss.js';
import { useId } from '../../utils/hooks/useId.js';

var ButtonType;
(function(ButtonType2) {
  ButtonType2["Secondary"] = "secondary";
  ButtonType2["Primary"] = "primary";
  ButtonType2["Link"] = "link";
})(ButtonType || (ButtonType = {}));
const bem = Bem.create("vai-button");
const Button = React.forwardRef(function Button2(props, ref) {
  const {
    dataTa,
    buttonType = ButtonType.Primary,
    buttonSize = Size.M,
    children,
    htmlId,
    className,
    startIcon: startIconProp,
    endIcon: endIconProp,
    type = "button",
    disabled,
    ...rest
  } = props;
  const id = useId(htmlId, ["button"]);
  const startIcon = startIconProp && /* @__PURE__ */ React.createElement("span", {
    className: bem.element("icon-start")()
  }, startIconProp);
  const endIcon = endIconProp && /* @__PURE__ */ React.createElement("span", {
    className: bem.element("icon-end")()
  }, endIconProp);
  const classes = addClass(bem.block(buttonType, buttonSize, startIconProp ? "start-icon" : void 0, endIconProp ? "end-icon" : void 0), className);
  return /* @__PURE__ */ React.createElement("button", {
    id: id.toString(),
    "data-ta": dataTa,
    className: classes,
    type,
    disabled,
    ref,
    ...rest
  }, startIcon, /* @__PURE__ */ React.createElement("span", {
    className: bem.element("text")()
  }, children), endIcon);
});
Button.metaProperties = ["disabled"];
Button.Type = ButtonType;

export { Button, ButtonType };
